/**
 * User validation utilities for hotel management system
 */

/**
 * Validates if a user has a hotel assignment and handles logout if not
 * @param {Object} user - User object from API
 * @param {Function} logoutFn - Logout function to call if validation fails
 * @returns {boolean} True if user is valid, false if user was logged out
 */
export const validateUserHasHotel = (user, logoutFn) => {
  if (!user) {
    return false;
  }
  
  // BLOCK: the legacy 4onboard setup account has no place in the staff app
  // (the onboarding wizard was removed from this frontend) — sign it out.
  if (user.username === '4onboard') {
    console.warn('4onboard user cannot access main system - signing out');
    if (logoutFn) {
      logoutFn();
    }
    window.location.href = '/login';
    return false;
  }
  
  // Check if user has hotel assignment
  const hasHotel = user.hotel || (user.user_profile && user.user_profile.hotel);
  
  if (!hasHotel) {
    console.warn('User has no hotel assignment - forcing logout');
    if (logoutFn) {
      logoutFn();
    }
    // Redirect to login page
    window.location.href = '/login';
    return false;
  }
  
  return true;
};

/**
 * Checks if user has hotel assignment without taking any action
 * @param {Object} user - User object from API
 * @returns {boolean} True if user has hotel assignment (4onboard user is always invalid)
 */
export const hasValidHotelAssignment = (user) => {
  if (!user) {
    return false;
  }
  
  // BLOCK: 4onboard user should never be considered valid for main system
  if (user.username === '4onboard') {
    return false;
  }
  
  // Check if user has hotel assignment
  return !!(user.hotel || (user.user_profile && user.user_profile.hotel));
};

export default {
  validateUserHasHotel,
  hasValidHotelAssignment
};